export default "__VITE_ASSET__7YeRphU0__"